import { styled } from "@stitches/react";
import { useState } from "react";
import { Button } from "@/vendor/Forge/dist";

const Wrapper = styled("div", {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    width: "fit-content",

    "& ul": {
        display: "flex",
        flexDirection: "column",
        whiteSpace: "nowrap",
        marginBottom: "0px",
    },
});

const ShowHideWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",

    "& .fe_c_button__content": {
        display: "flex",
        justifyContent: "left",
    },
});

interface Props {
    taoHistoryFieldData: string[];
}

const TaoHistoryField = ({ taoHistoryFieldData }: Props) => {
    const [showAll, setShowAll] = useState(false);

    return (
        <Wrapper>
            {taoHistoryFieldData.length > 10 && showAll == false ?
                <ShowHideWrapper>
                    <ul>
                        {taoHistoryFieldData.slice(0, 5).map((item) => <li key={item}>{item}</li>)}
                    </ul>
                    <Button data-testid="see-more-button" onClick={() => setShowAll(true)} variant="tertiary">See More</Button>
                </ShowHideWrapper>
            : taoHistoryFieldData.length > 10 && showAll == true ?
                <ShowHideWrapper>
                    <ul>
                        {taoHistoryFieldData.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                    <Button data-testid="see-less-button" onClick={() => setShowAll(false)} variant="tertiary">See Less</Button>
                </ShowHideWrapper>
            : taoHistoryFieldData.length == 1 ?
            taoHistoryFieldData
            :
                <ShowHideWrapper>
                    <ul>
                        {taoHistoryFieldData.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                </ShowHideWrapper>}
        </Wrapper>
    );
};

export default TaoHistoryField;
